<template>
	<v-container>
		<v-card outlined>
			<v-card-title>
				{{ vendor.name }}
				<create-machine-modal
					:vendor-id="parseInt($route.params.id)"
					@created="handleMachineCreated"
				/>
			</v-card-title>
			<v-card-text>
				<v-row>
					<v-col
						v-for="machine in machines"
						:key="machine.id"
						lg="3"
						md="4"
					>
						<router-link
							:to="`/machines/${machine.id}`"
							class="text-decoration-none body-1"
						>
							{{ machine.model_name }}
						</router-link>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
import Vue from 'vue';
import CreateMachineModal from "@/components/machines/create-machine-modal.vue";

export default {
	name: 'MachinesIndexView',
	components: {CreateMachineModal},
	data: () => ({
		vendor: {},
		machines: [],
	}),
	async beforeRouteEnter(to, from, next) {
		try {
			const response = await Vue.prototype.$http.get(`/api/v2/schemes/machines/vendors/${to.params.id}`);
			next(vm => {
				vm.vendor = response.data.data
			});
		} catch (e) {
			next(false);
		}
	},
	async created() {
		await this.fetchMachines();
	},
	methods: {
		async fetchMachines() {
			try {
				const response = await this.$http.get('/api/v2/schemes/machines', {
					params: {
						limit: 100,
						filter: {
							vendor: this.$route.params.id,
						},
					},
				});
				this.machines = response.data.data;
			} catch (e) {
				console.error('Error fetching machines');
			}
		},
		handleMachineCreated() {
			this.fetchMachines();
		},
	},
}
</script>

<style scoped>

</style>
